<template>
    <iframe
        v-if='media && media.media_type == "Documents" && media.type != "downloadable" && media.type != "pdf"'
        v-show='selected >= (images.length - 1)'
        :src='media.google_path'>
    </iframe>
</template>

<script>
    export default {
        props: ['media', 'selected', 'images']
    }
</script>

<style scoped>
    .test {
        color: white;
    }

    iframe {
        width: 100%;
        height: 100%;
        border: 1px solid #ddd;
        border-radius: 4px;
        transition: border 0.2s ease-in-out;
    }
</style>
